import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

const Title = ({ content }) => <Head><title>{content}</title></Head>;

Title.propTypes = {
  content: PropTypes.string,
};

Title.defaultProps = {
  content: 'Coursalytics',
};

export default Title;
